import PropTypes from 'prop-types';
import React from 'react';

import './AdminBrowseHomePagePreviewBanner.scss';

const AdminBrowseHomePagePreviewBanner = ({ message }) => {
  if (!message) {
    return null;
  }

  return (
    <section className="cp-admin-browse-home-page-preview-banner">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <p className="message">{message}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

AdminBrowseHomePagePreviewBanner.propTypes = {
  message: PropTypes.string.isRequired
};

export default AdminBrowseHomePagePreviewBanner;
